<div class="bdn-modal">

  <!-- ================= HEADER ================= -->
  <div class="bdn-header">
    <h2 *ngIf="!activeMode">Upload Fuel Document</h2>
    <h2 *ngIf="activeMode === 'BDN'">Manual BDN Entry</h2>
    <h2 *ngIf="activeMode === 'LOP'">Manual LOP Entry</h2>
    <mat-icon mat-dialog-close class="close-icon">close</mat-icon>
  </div>

  <!-- ================= LOADER ================= -->
  <div *ngIf="isUploading" class="processing-box">
    <p>Uploading and processing...</p>
    <div class="progress-bar">
      <div class="progress-fill"></div>
    </div>
  </div>

  <div *ngIf="!isUploading">
    
    <!-- ================= MODE SELECTION ================= -->
    <div *ngIf="!activeMode" class="upload-section">
      <div class="upload-box">
        <mat-icon class="upload-icon">post_add</mat-icon>
        <h3>Select Document Type</h3>
        <p>Please select whether you want to manually upload a BDN or LOP document.</p>
        
        <div class="upload-actions">
          <button class="upload-btn" (click)="setMode('BDN')">Add BDN</button>
          <button class="upload-btn secondary" (click)="setMode('LOP')">Add LOP</button>
        </div>
      </div>
    </div>

    <!-- ================= BDN FORM ================= -->
    <div *ngIf="activeMode === 'BDN'" class="form-container">
      <form [formGroup]="bdnForm">
        
        <div class="form-row">
          <div class="form-group">
            <label>Vessel Name <span class="required">*</span></label>
            <input type="text" formControlName="vessel_name" placeholder="Enter Vessel Name" class="form-input">
          </div>
          <div class="form-group">
            <label>IMO Number <span class="required">*</span></label>
            <input type="text" formControlName="imo" placeholder="Enter IMO Number" class="form-input">
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Port <span class="required">*</span></label>
            <input type="text" formControlName="port" placeholder="Enter Port" class="form-input">
          </div>
          <div class="form-group">
            <label>BDN Number <span class="required">*</span></label>
            <input type="text" formControlName="bdn_number" placeholder="Enter BDN Number" class="form-input">
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label>Bunker Date <span class="required">*</span></label>
            <app-custom-date-picker placeholder="Select Bunker Date" [controlname]="bdnForm.controls['bunkerDate']"></app-custom-date-picker>
          </div>
        </div>

        <h3 class="section-title">Products</h3>
        <div class="table-responsive">
          <table class="bdn-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Qty (MT)</th>
                <th>Qty (m³)</th>
                <th>Density @15°C</th>
                <th>Viscosity</th>
                <th>Sulphur %</th>
                <th>Flash Point</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of products; let i = index">
                <td>
                  <select class="cell-input" [(ngModel)]="p.product" [ngModelOptions]="{standalone: true}">
                    <option value="HFO">HFO</option>
                    <option value="VLSFO">VLSFO</option>
                    <option value="HSFO">HSFO</option>
                    <option value="LSMGO">LSMGO</option>
                    <option value="MGO">MGO</option>
                    <option value="ULSFO">ULSFO</option>
                    <option value="LNG">LNG</option>
                    <option value="BIOFUEL">BIOFUEL</option>
                  </select>
                </td>
                <td><input class="cell-input" type="number" min="0" step="any" [(ngModel)]="p.qty_mt" [ngModelOptions]="{standalone: true}"></td>
                <td><input class="cell-input" type="number" min="0" step="any" [(ngModel)]="p.qty_m3" [ngModelOptions]="{standalone: true}"></td>
                <td><input class="cell-input" type="number" min="0" step="any" [(ngModel)]="p.density_15c" [ngModelOptions]="{standalone: true}"></td>
                <td><input class="cell-input" type="number" min="0" step="any" [(ngModel)]="p.viscosity_50c_cst" [ngModelOptions]="{standalone: true}"></td>
                <td><input class="cell-input" type="number" min="0" step="any" [(ngModel)]="p.sulphur_percent" [ngModelOptions]="{standalone: true}"></td>
                <td><input class="cell-input" type="number" min="0" step="any" [(ngModel)]="p.flash_point_c" [ngModelOptions]="{standalone: true}"></td>
                <td class="action-cell">
                  <mat-icon class="delete-icon" (click)="removeProduct(i)">delete</mat-icon>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <button type="button" class="add-btn" (click)="addProduct()">+ Add Product</button>

      </form>
    </div>

    <!-- ================= LOP FORM ================= -->
    <div *ngIf="activeMode === 'LOP'" class="form-container">
      <form [formGroup]="lopForm">
        
        <div class="form-row">
          <div class="form-group">
            <label>IMO Number <span class="required">*</span></label>
            <!-- Show IMO input to load BDNs if not available -->
            <input *ngIf="bdnList.length === 0" type="text" [value]="bdnForm.value.imo" (change)="bdnForm.patchValue({imo: $any($event).target.value})" class="form-input" style="margin-bottom:10px;">
            <button *ngIf="bdnList.length === 0" type="button" class="upload-btn" (click)="fetchBdnList()">Fetch BDNs</button>
            <p *ngIf="bdnList.length > 0">IMO: <strong>{{bdnForm.value.imo || dialogData?.imo_number || dialogData?.imo || 'Unknown'}}</strong></p>
          </div>
        </div>

        <div *ngIf="bdnList.length > 0">
          <div class="form-row">
            <div class="form-group">
              <label>Select Associated BDN <span class="required">*</span></label>
              <select class="form-input" (change)="onBdnSelect($event)">
                <option value="" disabled selected>Select BDN</option>
                <option *ngFor="let bdn of bdnList" [value]="bdn.id">
                  BDN ID: {{ bdn.id }} | Doc No: {{ bdn.document_number }} | Date: {{bdn.document_date | date}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>LOP Date <span class="required">*</span></label>
              <app-custom-date-picker placeholder="Select LOP Date" [controlname]="lopForm.controls['lopDate']"></app-custom-date-picker>
            </div>
          </div>

          <h3 class="section-title">Discrepancies</h3>
          <div class="table-responsive">
            <table class="bdn-table">
              <thead>
                <tr>
                  <th>Fuel Type</th>
                  <th>Bunker Qty Receipt (MT)</th>
                  <th>Received Qty Ship (MT)</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let d of discrepancies; let i = index">
                  <td>
                    <select class="cell-input" [(ngModel)]="d.fuel_type" [ngModelOptions]="{standalone: true}">
                      <option value="HFO">HFO</option>
                      <option value="VLSFO">VLSFO</option>
                      <option value="HSFO">HSFO</option>
                      <option value="LSMGO">LSMGO</option>
                      <option value="MGO">MGO</option>
                      <option value="ULSFO">ULSFO</option>
                      <option value="LNG">LNG</option>
                      <option value="BIOFUEL">BIOFUEL</option>
                    </select>
                  </td>
                  <td><input class="cell-input" type="number" min="0" step="any" [(ngModel)]="d.bunker_qty_receipt_mt" [ngModelOptions]="{standalone: true}"></td>
                  <td><input class="cell-input" type="number" min="0" step="any" [(ngModel)]="d.received_qty_ship_mt" [ngModelOptions]="{standalone: true}"></td>
                  <td class="action-cell">
                    <mat-icon class="delete-icon" (click)="removeDiscrepancy(i)">delete</mat-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button type="button" class="add-btn" (click)="addDiscrepancy()">+ Add Discrepancy</button>
        </div>
      </form>
    </div>

    <!-- ================= FILE UPLOAD ================= -->
    <div *ngIf="activeMode" class="file-upload-section">
      <h3 class="section-title">Attachment <span class="required">*</span></h3>
      
      <div class="file-drop-area" *ngIf="!selectedFile">
        <mat-icon>attach_file</mat-icon>
        <p>Click to select PDF/Image</p>
        <input #fileInput type="file" accept="application/pdf,image/*" (change)="onFileSelect($event)" class="file-input-hidden">
      </div>

      <div class="selected-file" *ngIf="selectedFile">
        <mat-icon>insert_drive_file</mat-icon>
        <span>{{selectedFile.name}}</span>
        <mat-icon class="remove-file-icon" (click)="removeFile()">close</mat-icon>
      </div>
    </div>

    <!-- ================= FOOTER ================= -->
    <div *ngIf="activeMode" class="bdn-footer">
      <button class="upload-btn secondary" (click)="goBack()">Back</button>
      <button *ngIf="activeMode === 'BDN'" class="upload-btn success" (click)="submitBDN()">Submit BDN</button>
      <button *ngIf="activeMode === 'LOP'" class="upload-btn success" (click)="submitLOP()" [disabled]="!selectedBdnId">Submit LOP</button>
    </div>

  </div>
</div>
